<div class="error-wrapper">
  <h1>Sign in Error</h1>

  <p class="text-center">
    Unfortunately, an error occurred and we could not authenticate your account.
  </p>

  <mat-divider></mat-divider>

  <p>
    This error might be caused by an outdated version of Safari. Please, try updating your
    browser and signing in again.
  </p>
  <p>
    If updating Safari is not an option for you or you already have the latest version, the below steps
    must be executed in order to fix this issue:
  </p>

  <ol>
    <li>Go to Safari menu and click <b>"Preferences..."</b>;</li>
    <li>Navigate to the <b>"Privacy"</b> tab;</li>
    <li>Uncheck the <b>"Prevent cross-site-tracking"</b> checkbox;</li>
    <li>Go to  Safari menu and click <b>"Quit Safari"</b>;</li>
    <li>Open Safari;</li>
    <li>Try siging in again.</li>
  </ol>

  <mat-divider></mat-divider>

  <p class="text-center">
    If this information was not helpful to you and you are still unable to sign in, please
    <a href="javascript:void(0);" (click)="sendMailToL2Support()">contact our support team</a>.
  </p>
</div>
